<template>
  <section>
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <LinkageRole @roleSelected="roleSelected" @comSelected="comSelected" @proSelected="proSelected" :option="0"></LinkageRole>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="岗位名称" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSerch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="showAddView">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--列表-->
    <template>
      <el-table :data="datas" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="roleName" label="岗位名称">
        </el-table-column>
        <el-table-column prop="parentName" label="上级岗位">
        </el-table-column>
        <el-table-column prop="comName" label="公司" width="300">
        </el-table-column>
        <el-table-column prop="proName" label="项目">
        </el-table-column>
        <el-table-column prop="updateTime" label="创建时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="modifyName" label="创建人" align="center">
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <!--            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>-->
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
        <RoleForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"></RoleForm>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {roleSearch, roleDelete, roleDetail} from '../../api/api'
  import TableImg from "../command/TableImg";
  import RoleForm from "./RoleForm";
  import LinkageRole from "./LinkageRole";

  export default {
    name: "company",
    components: {LinkageRole, RoleForm, TableImg},
    data() {
      return {
        datas: [],
        page: 1,
        total: 0,
        limit: 15,
        filters: {},
        formVisible: false,
        detailsVisible: false,
        loading: false,
        option: 0,//0 添加 1 修改
        formData: {},
      }
    },
    methods: {
      //执行查询之前从子组件获取 需要的查询项
      comSelected: function (id) {
        this.filters.comId = id;
      },
      proSelected: function (proId) {
        this.filters.proId = proId;
      },
      roleSelected: function (roleId) {
        this.filters.roleId = roleId;
      },
      //查询数据
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.role, this.GLOBAL.option.select, this);
        this.loading = true;
        if (this.filters.comId == null) {
          this.filters.comId = this.GLOBAL.user.comId;
        }
        let params = {
          page: this.page,
          limit: this.limit,
          searchTab: this.filters.searchTab,
          comId: this.filters.comId,
          proId: this.filters.proId,
          parentId: this.filters.roleId
        };//请求参数
        roleSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.datas = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });
      },
      //查询
      doSerch: function () {
        this.searchData();
      },
      //分页查询
      searchPage(val) {
        this.page = val
        this.searchData();
      },
      resetForm: function () {
        this.filters = {}
      },
      //添加视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.role, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {isManager: '1'}
          this.formVisible = true;
        }

      },
      //编辑视图
      showEditView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.role, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          let params = {id: row.id};//请求参数
          roleDetail(params, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data

              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.role, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            roleDelete({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //查看详情
      openDetails: function (index, row) {
        this.GLOBAL.checkRole(null, null);
        this.detailsVisible = true
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.updateTime, "yyyy-MM-dd hh:mm:ss");
      },
    },
    mounted() {
      this.doSerch();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sysmanager/Role.vue